<template>
  <v-dialog v-model="invitationDialog" persistent max-width="400">
    <v-card>
      <v-card-title> ユーザー追加 </v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field
            v-model="address"
            label="招待メールアドレス"
            type="email"
            :rules="[emailValidation]"
            required
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error darken-1" text @click="closeDialog">
          キャンセル
        </v-btn>
        <v-btn color="green darken-1" text @click="inviteUser">
          招待する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    invitationDialog: {
      type: Boolean,
      required: true
    }
  },
  data: () => {
    return {
      address: null,
      emailValidation: (value) => {
        if (!value) {
          return '必ず入力してください'
        }
        const res = value.match(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        )
        if (res == null) {
          return '正しいeメールアドレスを入力してください'
        } else {
          return true
        }
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close-dialog')
      this.address = null
    },
    inviteUser () {
      this.$emit('invite-user', this.address)
      this.closeDialog()
    }
  }
}
</script>

<style scoped></style>
